import './knowledge-base.scss'
class ContentHub {
  block
  dropdowns = {}
  state = {}
  spinner
  content
  head

  constructor() {
    this.block = document.querySelector('[data-content-hub]')

    if (this.block) {
      this.spinner = document.querySelector('[data-content-hub-spinner]')
      this.content = document.querySelector('[data-content-hub-grid]')
      this.head = document.querySelector('.knowledge-base__filters-head')
      this.dropdowns = this.setDropdowns(document.querySelectorAll('[data-content-hub-dropdown]'))
      this.state = this.getInitialState()
      this.events()
    }
  }

  setDropdowns(nodeList) {
    if (!nodeList) {
      return {}
    }

    return Array.from(nodeList).reduce(
      (acc, element) => ({
        ...acc,
        [element.dataset.contentHubDropdown]: element,
      }),
      {}
    )
  }

  getInitialState() {
    const urlParams = new URLSearchParams(window.location.search)

    return {
      ...this.state,
      ...Object.keys(this.dropdowns).reduce(
        (acc, key) => ({
          ...acc,
          [key]: this.dropdowns[key].options[this.dropdowns[key].selectedIndex].value,
        }),
        {}
      ),
      s: urlParams.get('s') || '',
      page: 1,
    }
  }

  events() {
    document.addEventListener('click', (e) => {
      const page = e.target.closest('[data-page-id]')
      if (page) {
        this.state = {
          ...this.state,
          page: page.dataset.pageId,
        }

        this.update()
      }
    })

    Object.keys(this.dropdowns).map((key) => {
      this.dropdowns[key].addEventListener('change', (e) => {
        this.state = {
          ...this.state,
          page: 1,
          [key]: e.target.options[e.target.selectedIndex].value,
        }

        if (key === 'business') {
          const value = this.dropdowns[key].options[this.dropdowns[key].selectedIndex].value
          this.dropdowns['solution'].selectedIndex = 0
          this.state = {
            ...this.state,
            solution: '',
          }

          if (this.dropdowns[key].value === '') {
            Array.from(this.dropdowns['solution'].options).map((option) => {
              option.removeAttribute('hidden')
            })
          } else {
            Array.from(this.dropdowns['solution'].options).map((option) => {
              if (!('contentHubBusiness' in option.dataset)) {
                return
              }

              if (option.dataset.contentHubBusiness === value) {
                option.removeAttribute('hidden')
              } else {
                option.setAttribute('hidden', true)
              }
            })
          }
        }

        this.update()
      })
    })

    this.head.addEventListener('click', (e) => {
      e.preventDefault()
      e.target.parentElement.classList.toggle('active')
    })
  }

  update() {
    this.spinner.classList.add('active')

    fetch(`/wp-json/bics/v1/content-hub?${new URLSearchParams(this.state)}`)
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
      })
      .then((response) => (this.content.innerHTML = response.data))
      .catch(() => console.log('error'))
      .finally(() => {
        this.spinner.classList.remove('active')
        new window.DataLayer()
      })
  }
}

document.addEventListener('DOMContentLoaded', async function () {
  new ContentHub()
})
